import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    accounts: [],
    account: {},
    isLoading: false
};

const slice = createSlice({
    name: 'airbnbAccounts',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },

        startLoading(state) {
            state.isLoading = true;
        },

        getAccountsSuccess(state, action) {
            state.accounts = action.payload;
            state.isLoading = false;
        },

        getAccountSuccess(state, action) {
            state.account = action.payload;
            state.isLoading = false;
        },

        resetAccount(state) {
            state.account = {};
        },

        createAccountSuccess(state, action) {
            state.accounts.push(action.payload);
            state.account = action.payload;
            state.isLoading = false;
        },

        updateAccountSuccess(state, action) {
            const index = state.accounts.findIndex(acc => acc.id === action.payload.id);
            if (index !== -1) {
                state.accounts[index] = action.payload;
            }
            state.account = action.payload;
            state.isLoading = false;
        },

        deleteAccountSuccess(state, action) {
            state.accounts = state.accounts.filter(acc => acc.id !== action.payload);
            state.isLoading = false;
        }
    }
});

export default slice.reducer;

export function getAirbnbAccounts(search, showRemoved) {
    return async () => {
        try {
            dispatch(slice.actions.startLoading());
            let queryParams = new URLSearchParams();
            if (search) queryParams.append('search', search);
            if (showRemoved) queryParams.append('show_removed', showRemoved);
            
            const response = await axios.get(`/api/airbnb-accounts${queryParams.toString() ? '?' + queryParams.toString() : ''}`);
            dispatch(slice.actions.getAccountsSuccess(response.data.accounts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAirbnbAccount(id) {
    return async () => {
        try {
            dispatch(slice.actions.startLoading());
            const response = await axios.get(`/api/airbnb-accounts/${id}`);
            dispatch(slice.actions.getAccountSuccess(response.data.account));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function createAirbnbAccount(accountData) {
    return async () => {
        try {
            dispatch(slice.actions.startLoading());
            const response = await axios.post('/api/airbnb-accounts', accountData);
            dispatch(slice.actions.createAccountSuccess(response.data.account));
            return response.data;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            throw error;
        }
    };
}

export function updateAirbnbAccount(id, accountData) {
    return async () => {
        try {
            dispatch(slice.actions.startLoading());
            const response = await axios.put(`/api/airbnb-accounts/${id}`, accountData);
            dispatch(slice.actions.updateAccountSuccess(response.data.account));
            return response.data;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            throw error;
        }
    };
}

export function deleteAirbnbAccount(id) {
    return async () => {
        try {
            dispatch(slice.actions.startLoading());
            await axios.delete(`/api/airbnb-accounts/${id}`);
            dispatch(slice.actions.deleteAccountSuccess(id));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            throw error;
        }
    };
}

export function resetAirbnbAccount() {
    return () => {
        dispatch(slice.actions.resetAccount());
    };
}